import { Box, Paragraph } from 'grommet'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  margin: 0 ${({ theme }) => theme.spaces[2] + theme.spaces[1]}px;
  min-height: 50px;
  min-width: 90px;

  &:nth-child(4),
  &:nth-child(5),
  &:nth-child(6),
  &:nth-child(7) {
    min-width: 180px;

    ${({ theme }) => theme.below.laptopM`
      min-width: 110px;
    `}

    ${({ theme }) => theme.below.laptop`
      min-width: 160px;
    `}

    ${({ theme }) => theme.below.tablet`
      min-width: 122px;
    `}
  }

  ${({ theme }) => theme.below.laptopM`
    min-width: 110px;
  `}

  ${({ theme }) => theme.below.laptop`
    min-width: 160px;
    margin-bottom: ${theme.spaces[2]}px;
  `}

  ${({ theme }) => theme.below.tablet`
    min-width: 122px;
    margin-bottom: ${theme.spaces[4]}px;
  `}
`

export const Amount = styled(Paragraph)`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'title4')}

  color: ${({ theme }) => theme.newColors.secondary};
  font-size: 14px;
`

export const Role = styled(Amount)`
  border-bottom: 1px solid ${({ theme }) => theme.newColors.coldGray};
  color: ${({ theme }) => theme.newColors.darkGray};
`
